import { z } from "zod/v4";

const OperatorSchema = z.object({
  id: z.number(),
  name: z.string(),
  crmCustomerId: z.number().nullish(),
});

const OperatorsResponseSchema = z.object({
  operators: z.array(OperatorSchema),
});

const OperatorsSearchSchema = z.object({
  operator: z.literal("1"),
});

type Operator = z.infer<typeof OperatorSchema>;
type OperatorId = Operator["id"];

export { OperatorSchema, OperatorsResponseSchema, OperatorsSearchSchema };
export type { Operator, OperatorId };
